const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StoreManagerPermissionQuery: any = {
    Staff: Backofficebff + '/v1/store-manager-permission/staff',
    History: Backofficebff + '/v1/store-manager-permission/history',
    HasFeature: Backofficebff + '/v1/store-manager-permission/has-feature',
};
